"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(mimetypes) {
    let temp = [];
    for (let mimetype of mimetypes) {
        temp.push({
            description: mimetype.description,
            type: mimetype.type,
            suffixes: mimetype.suffixes
        });
    }
    return temp;
}
exports.default = default_1;
